export default "__VITE_ASSET__c1ef1783__"